'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _findIndex2 = require('lodash/findIndex');

var _findIndex3 = _interopRequireDefault(_findIndex2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class, _descriptor;

var _mobx = require('mobx');

var _util = require('../utils/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PriorFundingStore = (_class = function () {
  function PriorFundingStore(LienStore, SessionStore, transport) {
    _classCallCheck(this, PriorFundingStore);

    _initDefineProp(this, 'priorFundingOptions', _descriptor, this);

    this.transport = transport;
    this.lienStore = LienStore;
    this.sessionStore = SessionStore;
    this.fetchPriorFundingOptions();
  }

  _createClass(PriorFundingStore, [{
    key: 'create',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_case, data) {
        var priorFunding, existing, application;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.transport.post('/prior-fundings/', { data: _extends({}, (0, _util.nullifyEmptyStrings)(data), {
                    case: _case.id,
                    funder_name: data.funder_name || ''
                  }) });

              case 2:
                priorFunding = _context.sent;


                // Push onto local case
                existing = (0, _findIndex3.default)(_case.prior_fundings, { id: priorFunding.id });

                if (existing > -1) {
                  (0, _mobx.extendObservable)(_case.prior_fundings[existing], priorFunding);
                } else {
                  _case.prior_fundings.push(priorFunding);
                }

                // Link to any local applications
                if (priorFunding.application) {
                  application = (0, _find3.default)(_case.applications, { id: priorFunding.application });

                  application.prior_funding = priorFunding;
                }

                // Refresh connected lien
                if (priorFunding.lien) {
                  this.lienStore.list({ caseId: _case.id });
                }

                this.fetchPriorFundingOptions();
                return _context.abrupt('return', priorFunding);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: 'fetchPriorFundingOptions',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var priorFundingOptions;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.sessionStore.user) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return this.transport.get('/prior-fundings/prior_funders/');

              case 3:
                priorFundingOptions = _context2.sent;

                this.priorFundingOptions = (priorFundingOptions || []).map(function (name) {
                  return { name: name };
                });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchPriorFundingOptions() {
        return _ref2.apply(this, arguments);
      }

      return fetchPriorFundingOptions;
    }()
  }, {
    key: 'retrieve',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id, options) {
        var prior_funding;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.transport.get('/prior-fundings/:id/', _extends({ urlParams: { id: id } }, options));

              case 2:
                prior_funding = _context3.sent;
                return _context3.abrupt('return', prior_funding);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function retrieve(_x3, _x4) {
        return _ref3.apply(this, arguments);
      }

      return retrieve;
    }()
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return PriorFundingStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'priorFundingOptions', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, 'create', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'create'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'fetchPriorFundingOptions', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'fetchPriorFundingOptions'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'retrieve', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'retrieve'), _class.prototype)), _class);
var _default = PriorFundingStore;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PriorFundingStore, 'PriorFundingStore', '/app/src/stores/PriorFundingStore.js');
  reactHotLoader.register(_default, 'default', '/app/src/stores/PriorFundingStore.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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